import React from 'react';
import { Asset } from '../../../types/asset';
import { RichText } from '../../richText';
import { Document } from '@contentful/rich-text-types';
import { Block } from '../../other/block';

interface TestimonialProps {
  name: string;
  position: string;
  company: string;
  image?: Asset;
  content: Document;
  backgroundColour?: string;
}

export const Testimonial: React.FC<TestimonialProps> = ({
  name, position, company, image, content, backgroundColour,
}) => {
  return (
    <Block backgroundColour={'transparent'}>
      <div className="flex flex-col items-start max-w-4xl mx-auto md:flex-row sm:items-center md:items-start">
        <div className="flex-shrink-0 w-24 h-24 mt-1 mb-10 mr-12 bg-white rounded-full">
          <img className="rounded-full" src={image && image.url} alt={image && image.name} />
        </div>

        <div className="w-auto">
          <div className="mb-5 text-left">
            <RichText content={content} />
          </div>
          <div className="text-sm text-left">
            <span className="font-semibold">{name}</span>
            <span> {position} - </span>
            <span>{company}</span>
          </div>
        </div>
      </div>
    </Block>
  );
};
